import { useAuth0 } from "@auth0/auth0-react";
import { Browser } from "@capacitor/browser";
import { isPlatform } from "@ionic/react";
import { useContext, useCallback } from "react";
import { WidgetContext } from "src/contexts/WidgetContext";
import { useNavigate } from "react-router";
import { Capacitor } from "@capacitor/core";

//Custom Hook to handle doLogOut
export const useDoLogout = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const isNative = Capacitor.isNativePlatform(); // isNative is for capacitor (maybe more accurate)
  const iosOrAndroid = isPlatform("hybrid"); // isPlatform("hybrid") is for ionic (its possible for ipad its fails)

  // isRunningNatively is for capacitor and ionic (even more accurate)
  const isRunningNatively = isNative || iosOrAndroid;
  //Get function resetAppState to reset app
  const { resetAppState } = useContext(WidgetContext);

  const frontendUriLogout = process.env.REACT_APP_FRONTEND_URI_LOGOUT;
  const appId = "com.rotogpt.chat";
  const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;

  const doLogOut = useCallback(async () => {
    //Function to reset all sessions and states in app
    resetAppState();

    // Define returnTo URL based on platform
    const returnTo = isRunningNatively ? `${appId}://${auth0Domain}/capacitor/${appId}/callback` : frontendUriLogout;

    await logout({
      logoutParams: {
        returnTo: returnTo,
      },
      openUrl: async (url) => {
        // Redirect using Capacitor's Browser plugin
        await Browser.open({
          url,
          windowName: "_self",
        });

        // // If its iOS or Android, navigate to “/”
        // if (isRunningNatively) {
        //   // navigate("/");
        //   window.location.replace("/"); //replace this instead of navigate("/") because its more accurate to restore the app state
        // }
      },
    });
  }, [logout, navigate, resetAppState, iosOrAndroid, auth0Domain, frontendUriLogout]);

  return doLogOut;
};

export default useDoLogout;
